import React from 'react';

export const ExpandableDetailContext = React.createContext({
  isExpanded: false,
  toggleExpand: () => {},
});

export const ExpandableDetail: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const contextValue = React.useMemo(() => {
    const toggleExpand = () => {
      setIsExpanded(prev => !prev);
    };
    return { isExpanded, toggleExpand };
  }, [isExpanded]);

  return <ExpandableDetailContext.Provider value={contextValue}>{children}</ExpandableDetailContext.Provider>;
};
